import { render, staticRenderFns } from "./RuleScopeFiltersCard.vue?vue&type=template&id=4fb1b1ec&scoped=true"
import script from "./RuleScopeFiltersCard.vue?vue&type=script&lang=ts"
export * from "./RuleScopeFiltersCard.vue?vue&type=script&lang=ts"
import style0 from "./RuleScopeFiltersCard.vue?vue&type=style&index=0&id=4fb1b1ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb1b1ec",
  null
  
)

export default component.exports